import axios from 'axios';

// 创建axios实例
const service = axios.create({
  baseURL: 'https://rarmtguci.wzgo.cn',
  timeout: 10000
});

// 请求拦截
service.interceptors.request.use((config) => {
  config.headers['Content-Type'] = 'application/json;charset=utf-8';
  return config;
});

// 响应拦截器
service.interceptors.response.use((res) => {
  return res.data;
});

export default service;
